import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

import { ButtonAnalyticParams } from '@amfam/shared/analytics';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import { CopyService } from '@amfam/shared/utility/shared-services';

@Component({
  selector: 'ds-autopay-overview-card',
  templateUrl: './autopay-overview-card.component.html',
  styleUrls: [
    './autopay-overview-card.component.scss',
    '../../programs/programs-overview.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AutopayOverviewCardComponent implements OnInit {
  @Input() buttonAnalyticData: ButtonAnalyticParams;
  @Output() ctaClickEvent = new EventEmitter();
  mutipleAutopaySetupBtnContent: string;
  isAutopayCardEnhancementsEnabled: boolean;

  constructor(
    public copyService: CopyService,
    private featureFlagService: FeatureFlagService
  ) {}

  ngOnInit() {
    this.isAutopayCardEnhancementsEnabled = this.featureFlagService.isEnabled(
      'autopay_card_enhancements'
    );
    this.mutipleAutopaySetupBtnContent = this.copyService.getCopy(
      'overview.mutipleAutopaySetupBtn'
    );
  }
}
